var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7398 14.9545L28.7027 13.162C29.8912 12.9243 31 13.8333 31 15.0453V30.8463C31 32.0583 29.8912 32.9673 28.7027 32.7296L19.7398 30.9371C18.8421 30.7575 18.1959 29.9693 18.1959 29.0537V16.8379C18.1959 15.9223 18.8421 15.1341 19.7398 14.9545Z",
    fill: "#D59829",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1959 15.2635L27.6509 13.3725C29.3835 13.0259 31 14.3512 31 16.1181V29.7738C31 31.5407 29.3835 32.8659 27.6509 32.5194L18.1959 30.6284",
    stroke: "#D59829",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5133 22.946H18.1958",
    stroke: "#D59829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4763 26.7872L23.2322 23.9703C23.9151 23.4581 23.9151 22.4338 23.2322 21.9216L19.4763 19.1047",
    stroke: "#D59829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.2 0.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.71846a455b884506128ebfe157ec8137.svg";
export { ForwardRef as ReactComponent };